import { ChangeDetectionStrategy, Component, computed, inject, input } from "@angular/core";
import { toSignal } from "@angular/core/rxjs-interop";
import { RouterLink } from "@angular/router";
import { OrganizationAccountGroups } from "@front/m19-models";
import {
  IButtonDirective,
  IDropdownMenuComponent,
  IDropdownMenuItemDirective,
  IDropdownMenuTriggerDirective,
  ITableTdDirective,
  IIconComponent,
} from "@front/m19-ui";
import { TranslocoDirective } from "@jsverse/transloco";
import { AccountSettingsV2Service } from "@m19-board/services/account-settings.service";
import { AccountSelectionQueryParams, AuthService, isSuspendedForAdmin } from "@front/m19-services";

@Component({
  selector: "[app-organization-list-row]",
  imports: [
    TranslocoDirective,
    ITableTdDirective,
    IButtonDirective,
    IDropdownMenuTriggerDirective,
    IDropdownMenuComponent,
    IDropdownMenuItemDirective,
    RouterLink,
    IIconComponent,
  ],
  templateUrl: "./organization-list-row.component.html",
  providers: [AccountSettingsV2Service],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrganizationListRowComponent {
  private readonly accountSettingsService = inject(AccountSettingsV2Service);
  private readonly authService = inject(AuthService);

  readonly productTour = toSignal(this.authService.isProductTour$, { initialValue: false });

  organization = input.required<OrganizationAccountGroups>();
  isAdmin = input<boolean>(false);

  isSuspended = computed(() => isSuspendedForAdmin(this.organization()));
  accountGroupsLength = computed(() => this.organization()?.accountGroups.length ?? 0);
  accountLength = computed(
    () =>
      this.organization()
        ?.accountGroups.flatMap((group) => group.resources.length)
        .reduce((a, b) => a + b, 0) ?? 0,
  );
  orgQueryParams = computed(() => ({
    [AccountSelectionQueryParams.orgId]: this.organization().id,
  }));

  openEditDefaultCampaignLabelModal() {
    this.accountSettingsService.openEditDefaultCampaignLabelModal(this.organization());
  }
}
